module.exports = __webpack_public_path__ + "img/apk.145fb9da.jpg";